import { globalModel } from '@/model'

const onePxRem = 1 / (globalModel.state.isTV ? 192 : 37.5)

/**
 * 转换 375 宽下的像素值为 rem 值。
 *
 * @param {number} px 像素值
 * @returns number
 */
export function pxToRem(px) {
  return px * onePxRem
}
